import { mapGetters } from 'vuex'

export var flagsMixin = {
  computed: {
    ...mapGetters({
      mixinFlagsList: 'flagsModule/getFlags',
    }),
  },
  methods: {
    getFlagSetado(flagName) {
      if (!this.$store.getters['authModule/getAuthUser']) return false

      const flag = this.mixinFlagsList.filter(
        (flag) => flag.DESCRICAO == flagName
      )

      return flag[0] ?? false
    },
  },
}
